import { useCallback, useEffect, useState } from "react";
import { fetchRequestCount } from "../api/client";

const POLL_INTERVAL = 30_000;

export function usePendingCount() {
  const [count, setCount] = useState(0);

  const load = useCallback(() => {
    fetchRequestCount({ status: "needs_review" })
      .then((r) => setCount(r.count))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, POLL_INTERVAL);
    return () => clearInterval(id);
  }, [load]);

  return { count, refresh: load };
}
